/**
 * Created by wangmc on 2017/11/21.
 */
import $api from 'teld-web-component'
import { domain } from 'teld-web-component/lib/env'
import { readCookie, eraseCookie } from 'teld-web-component/lib/method'

$api.axiosIntercept.login = () => {

    if (readCookie('teldc') != '1') {
        eraseCookie("teldk")
        eraseCookie("teldb")
        eraseCookie("teldc")
        eraseCookie("teldz")
    }
    eraseCookie("TELDSID");
    eraseCookie("telda");
    window.location.href = `//user${domain}/newlogin?source=7&redirect_uri=${encodeURIComponent(window.location.href)}`;
}

/**
 * 示例请求
 */
export const GetActivityInfoList = (params, suc, fail) => {
    $api.post('CMS-GetActivityInfoList', params, suc, fail)
}
// 获取更多案例
export const GetCustRuleCodeAndCodeItems = (params, suc, fail) => {
    $api.ajax({
        url: 'CPUBSG-GetCustRuleCodeAndCodeItems',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: true
    })
}
export const GetCaseInformationByIndustry = (params, suc, fail) => {
    $api.ajax({
        url: 'OpenMs-GetCaseInformationByIndustry',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: true
    })
}
export const GetHomeInfo = (params, suc, fail) => {
    $api.ajax({
        url: 'OpenMs-MerchantStatistics',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: true
    })
}
export const GetConfigRelease = (params, suc, fail) => {
    $api.ajax({
        url: 'CMS-GetConfigRelease',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: true
    })
}
export const GetContentById = (params, suc, fail) => {
    $api.ajax({
        url: 'CMS-GetContentById',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: true
    })
}

export const LoginWithEncryptPwd = (params, suc, fail) => {
    return $api.ajax({
        methods: 'post',
        url: 'UserAPI-WEBUI-LoginWithEncryptPwd',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: true
    })
}

export const GetRSAParameters = (params, suc, fail) => {
    return $api.ajax({
        url: 'UserAPI-WEBUI-GetRSAParameters',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: true
    })
}
// 互联互通认证接口
export const AddHlhtMerchant = (params, suc, fail) => {
    return $api.ajax({
        url: 'OpenMs-AddHlhtMerchant',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: false
    })
}
//  获取认证信息接口

export const GetHlhtMerchantByUser = (params, suc, fail) =>{
    return $api.ajax({
        url: 'OpenMs-GetHlhtMerchantByUser',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: false
    })
}

// 认证不通过再次提交接口

export const reAddHlhtMerchant = (params, suc, fail) => {
    return $api.ajax({
        url: 'OpenMs-AddHlhtMerchant',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: false
    })
}

// 	认证通过修改联系方式接口

export const UpdateHlhtMerchant = (params, suc, fail) => {
    return $api.ajax({
        url: 'OpenMs-UpdateHlhtMerchant',
        data: params,
        success: suc,
        failure: fail,
        noIndentity: false
    })
}

export const GetCurrentUser = (params, suc, fail) => {
    $api.post('CSC-getCustInfomation', params, suc, fail)
}

export const GetHlhtMerchant = (params, suc, fail) => {
    $api.post('OpenMs-GetHlhtMerchantByUser', params, suc, fail)
}

export const logOut = (params, suc, fail) => {
    $api.post('UserAPI-WEBUI-Logout', params, suc, fail)
}



// WEBPACK FOOTER //
// ./src/service/index.js